import type * as React from 'react';

import classNames from 'classnames';

import Button from '../../ui/button/button';

import iconikAgentLogo from '../../../../agent/static/images/iconik-agent.svg';

import styles from './uploads_panel_widget.module.css';

type Props = {
  fullscreen: boolean;
  promptText: string;
  closePrompt: () => void;
};
const AgentPrompt: React.FC<Props> = ({
  fullscreen,
  promptText,
  closePrompt,
}) => {
  return (
    <div
      className={classNames(styles.agent_prompt, {
        [styles.agent_prompt_fullscreen]: fullscreen,
      })}
      onClick={() => {
        window.open('http://iconik.io/agent', '_blank');
      }}
    >
      <Button
        className={styles.close_agent_prompt}
        onClick={(event) => {
          event.stopPropagation();
          closePrompt();
        }}
        noBorder
        iconName="close"
        wideBasis={false}
        aria={{ label: 'Close agent prompt' }}
      />
      <img src={iconikAgentLogo} width={32} height={32} alt="iconik Logo" />
      <p>{promptText}</p>
    </div>
  );
};

export default AgentPrompt;
